import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Grid } from '@mui/material'
import { TextField } from 'src/Libs/inputs/formik'
import { useFormikContext } from 'formik'

const AddWallboxFormFields: React.VFC<unknown> = () => {
  const { t } = useCustomTranslation()
  const { handleSubmit } = useFormikContext()

  return (
    <form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={12}>
          <TextField name="ipAddress" label={t('systemSettings.wallboxes.addNew.form.ipAddr')} />
        </Grid>
      </Grid>
    </form>
  )
}

export default AddWallboxFormFields
